import { render, staticRenderFns } from "./PersistParametroRelatorioView.vue?vue&type=template&id=457e2796&"
import script from "./PersistParametroRelatorioView.vue?vue&type=script&lang=ts&"
export * from "./PersistParametroRelatorioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports